// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6be3f5dc","769":"5e418c07"}[chunkId] + ".chunk.js";
};